// extracted by mini-css-extract-plugin
export default {"icon":"_1PTI","title":"_3gGN","text":"fYkA","button":"zMsa","container":"_3kdz"};